<h2 mat-dialog-title>
  <mat-icon style="margin-right: 0.5rem;">code</mat-icon>
  Technical Analysis
</h2>

<form (ngSubmit)="analyzeTechnical()" #analysisForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <div *ngIf="!analysis && !loading" class="form-fields-vertical">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Ask a technical question about the algorithm</mat-label>
        <textarea
          matInput
          name="question"
          [(ngModel)]="question"
          placeholder="e.g., Why is the solver taking so long? How do the multi-resource constraints work?"
          rows="3"
          maxlength="500"
          required>
        </textarea>
        <mat-hint>{{question.length}}/500</mat-hint>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="loading-section">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Analyzing algorithm with AI...</p>
    </div>

    <div *ngIf="analysis && !loading" class="result-section">
      <div class="analysis-header">
        <div class="analysis-type-badge type-technical">
          Technical Analysis
        </div>
        <div class="question-display">
          <strong>Q:</strong> {{analysis.question}}
        </div>
      </div>

      <div class="answer-section">
        <h4><mat-icon>engineering</mat-icon> Technical Explanation</h4>
        <div class="markdown-content">{{ analysis.technicalExplanation }}</div>
      </div>

      <div class="answer-section">
        <h4><mat-icon>settings</mat-icon> Algorithm Details</h4>
        <div class="markdown-content">{{ analysis.algorithmDetails }}</div>
      </div>

      <div class="answer-section">
        <h4>
          <mat-icon>smart_toy</mat-icon> 
          LLM Prompt for Coding Agent
          <button
            mat-icon-button
            (click)="copyToClipboard(analysis.llmPrompt)"
            matTooltip="Copy to clipboard"
            style="margin-left: auto;"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </h4>
        <div class="llm-prompt-content">{{ analysis.llmPrompt }}</div>
      </div>

      <div class="answer-section" *ngIf="analysis.codeReferences.length > 0">
        <h4><mat-icon>code</mat-icon> Code References</h4>
        <ul class="code-references-list">
          <li *ngFor="let ref of analysis.codeReferences">{{ ref }}</li>
        </ul>
      </div>

      <div class="answer-section proposed-instructions" *ngIf="analysis.proposedExtraAIInstructions">
        <h4>
          <mat-icon>lightbulb</mat-icon>
          Proposed Constraint Improvement Instructions
        </h4>
        <div class="instruction-content">
          <p><strong>Affected Constraint ID:</strong> {{ analysis.affectedConstraintId }}</p>
          <p class="instructions-text">{{ analysis.proposedExtraAIInstructions }}</p>
        </div>
        <button
          mat-raised-button
          color="accent"
          (click)="acceptProposedInstructions()"
          [disabled]="acceptingInstructions"
          class="accept-button"
        >
          <mat-icon>check_circle</mat-icon>
          <span *ngIf="!acceptingInstructions">Accept & Regenerate Constraint</span>
          <span *ngIf="acceptingInstructions">Applying Instructions...</span>
        </button>
      </div>
    </div>

    <div *ngIf="error" class="error-section">
      <mat-icon class="error-icon">error</mat-icon>
      <p>{{error}}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" *ngIf="!loading">
      Cancel
    </button>
    
    <button 
      mat-flat-button 
      color="primary" 
      type="submit"
      [disabled]="!question.trim() || loading"
      *ngIf="!analysis">
      <mat-icon>code</mat-icon>
      Analyze
    </button>

    <button 
      mat-button 
      (click)="resetAnalysis()" 
      *ngIf="analysis && !loading">
      <mat-icon>refresh</mat-icon>
      Ask Another Question
    </button>
  </mat-dialog-actions>
</form>
